<template>
  <div>
    <div class="popover-online-inquire">
      <div class="inquire-top">
        <img class="header-img" :src="csData.wwx_avatar || customerImage"></img>
        <div class="name">{{ csData.cs_name }}</div>
        <div class="title">签证专家 1V1 服务</div>
      </div>
      <div class="inquire-btn" @click="$emit('openExcluive')">
        在线咨询
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import customerImage from '@/assets/imgs/homepage/fixed-right-service/service-customer.png';


export default {
  data() {
    return {
      customerImage,
    };
  },
  computed: {
    ...mapState('user', [
      'peerCSData',
    ]),
    csData() {
      return this.peerCSData || {};
    },
  },
};
</script>

<style lang="less" scoped>
.popover-online-inquire {
  padding: 0 10px;
  .inquire-top {
    padding: 16px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #E9EEF2;
    >div {
      white-space: nowrap;
    }
    .header-img {
      width: 66px;
      height: 66px;
      border-radius: 50%;
    }
    .name {
      margin-top: 4px;
      font-size: 14px;
      color: #2F333D;
      line-height: 18px;
    }
    .title {
      margin-top: 4px;
      font-size: 12px;
      color: #5F666E;
      line-height: 17px;
    }
  }
  .inquire-btn {
    padding: 16px 0;
    font-size: 16px;
    color: #599FFF;
    line-height: 22px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/popover/popover-online-inquire.vue